export default {"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111};